/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ApiError from '../model/ApiError';
import CreateJobStatusRequest from '../model/CreateJobStatusRequest';
import DeleteStatusAndTransferJobs from '../model/DeleteStatusAndTransferJobs';
import JobStatus from '../model/JobStatus';
import ProblemDetails from '../model/ProblemDetails';
import SuccessResponse from '../model/SuccessResponse';
import UpdateJobStatusRequest from '../model/UpdateJobStatusRequest';

/**
* JobStatus service.
* @module api/JobStatusApi
* @version V1
*/
export default class JobStatusApi {

    /**
    * Constructs a new JobStatusApi. 
    * @alias module:api/JobStatusApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createJobStatus operation.
     * @callback module:api/JobStatusApi~createJobStatusCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateJobStatusRequest} [createJobStatusRequest] 
     * @param {module:api/JobStatusApi~createJobStatusCallback} callback The callback function, accepting three arguments: error, data, response
     */
    createJobStatus(opts, callback) {
      opts = opts || {};
      let postBody = opts['createJobStatusRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/job-statuses', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getJobStatusesByAccount operation.
     * @callback module:api/JobStatusApi~getJobStatusesByAccountCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/JobStatus>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/JobStatusApi~getJobStatusesByAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/JobStatus>}
     */
    getJobStatusesByAccount(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = [JobStatus];
      return this.apiClient.callApi(
        '/job-statuses', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the replaceAndDeleteStatus operation.
     * @callback module:api/JobStatusApi~replaceAndDeleteStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SuccessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/DeleteStatusAndTransferJobs} [deleteStatusAndTransferJobs] 
     * @param {module:api/JobStatusApi~replaceAndDeleteStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SuccessResponse}
     */
    replaceAndDeleteStatus(opts, callback) {
      opts = opts || {};
      let postBody = opts['deleteStatusAndTransferJobs'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SuccessResponse;
      return this.apiClient.callApi(
        '/job-statuses/replace', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateStatus operation.
     * @callback module:api/JobStatusApi~updateStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/JobStatus} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateJobStatusRequest} [updateJobStatusRequest] 
     * @param {module:api/JobStatusApi~updateStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/JobStatus}
     */
    updateStatus(opts, callback) {
      opts = opts || {};
      let postBody = opts['updateJobStatusRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = JobStatus;
      return this.apiClient.callApi(
        '/job-statuses', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
